import React from 'react';
import PropTypes from "prop-types";
import Fragment from "common/src/components/widget/Fragment";
import FloatingLabelTagsWrapper from "common/src/components/widget/FloatingLabelTagsWrapper";
import {useTranslation} from "react-i18next";
import useFilterColumnsCard from "./useFilterColumnsCard";
import FilterAddForm from "./FilterAddForm";

const DynamicFilterColumnsCard = (props) => {
    const {t} = useTranslation();
    const state = useFilterColumnsCard({
        options: props.options,
        numericFilterFormField: props.numericFilterFormField,
        stringFilterFormField: props.stringFilterFormField,
        timeRangeFilterFormField: props.timeRangeFilterFormField,
        timestampFilterFormField: props.timestampFilterFormField,
        mode: "DYNAMIC",
    });

    return (<div className="card">
        <header className="card-header">
            <p className="card-header-title">
                <span className="icon fz fz-filter1 medium mr-1"/>
                <span>{t('dataset.filter.dynamic_title')}</span>
            </p>
        </header>
        <div className="card-content">
            <div>
                <FloatingLabelTagsWrapper
                    label={t('dataset.filter.dynamic')}
                    tags={state.appliedFilters}
                    onTagRemove={state.handleTagRemove}
                    formatter={state.getFormatter}
                    disabled={props.disabled}
                />
                <Fragment rendered={(props.options != null && !props.disabled)}>
                    <FilterAddForm state={state}/>
                </Fragment>
            </div>
        </div>
    </div>);
};

DynamicFilterColumnsCard.propTypes = {
    options: PropTypes.array,
    numericFilterFormField: PropTypes.object,
    stringFilterFormField: PropTypes.object,
    timeRangeFilterFormField: PropTypes.object,
    timestampFilterFormField: PropTypes.object,
    disabled: PropTypes.bool.isRequired
};

DynamicFilterColumnsCard.defaultProps = {
    disabled: false
};

export default DynamicFilterColumnsCard;
